import { render } from "./QuestionareItem.vue?vue&type=template&id=1a09a763&scoped=true"
import script from "./QuestionareItem.vue?vue&type=script&lang=js"
export * from "./QuestionareItem.vue?vue&type=script&lang=js"

import "./QuestionareItem.vue?vue&type=style&index=0&id=1a09a763&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a09a763"]])

export default __exports__